import { getCoChatUserInteractionsDetails } from "../../api/cochat";

import { CO_CHAT_USER_DETAILS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loading: false,
  agentDetails: {} as any,
  interactionDetails: [] as any,
  selectedAgent: "",
  isInteractionTabOpen: false,
};
const coChatUserDetailsSlice = createSlice({
  name: CO_CHAT_USER_DETAILS,
  initialState,
  reducers: {
    openInteractionTab: (state) => {
      state.isInteractionTabOpen = true;
    },
    closeInteractionTab: (state) => {
      state.isInteractionTabOpen = false;
    },
    updateSelectedAgent: (state, { payload }) => {
      state.selectedAgent = payload;
    },
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(getCoChatUserInteractionsDetails.pending, (state, _) => {
      state.loading = true;
    });
    builder.addCase(getCoChatUserInteractionsDetails.fulfilled, (state, { payload }: any) => {
      if (payload?.data?.statusCode === 200) {
        state.interactionDetails = payload?.data?.result;
      }
      state.loading = false;
    });
    builder.addCase(getCoChatUserInteractionsDetails.rejected, (state, _) => {
      state.loading = false;
    });
  },
});
export const cochatUserDetailsActions = coChatUserDetailsSlice.actions;
export default coChatUserDetailsSlice.reducer;
